import { render } from "./UserAuditLogs.vue?vue&type=template&id=1728d0b1&scoped=true"
import script from "./UserAuditLogs.vue?vue&type=script&lang=js"
export * from "./UserAuditLogs.vue?vue&type=script&lang=js"

import "./UserAuditLogs.vue?vue&type=style&index=0&id=1728d0b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1728d0b1"]])

export default __exports__